import {
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnChanges, OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from "@angular/core";
import { DOCUMENT, ViewportScroller } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MENU_ITEMS_LABELS } from './config/wording';
import { ILabels } from "libraries/interfaces/ILabels";
import { ISummarySectorAir, ISummarySectorStay } from "../sectors/components/shared/interfaces/ISummary";
import { SectorService } from "libraries/service/sector/sector.service";
import {
    IGetBookingsAirResponse,
    IGetBookingsStayResponse
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { map, take, delay, tap } from "rxjs/operators";
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { EAirBookingPermissions } from "libraries/component/booking-information/e-air-booking-permissions.enum";
import {
    faAngleDoubleUp,
    IconDefinition,
    faAngleDoubleDown,
    faCircle,
    faLongArrowAltDown,
    faExclamationTriangle, faMoneyBill
} from "@fortawesome/free-solid-svg-icons";
import { faCircle as faCircleThin } from "@fortawesome/free-regular-svg-icons";
import { Subscription } from "rxjs";
import { MenuService } from "./menu.service";
import { ESashaPermissions } from "libraries/enums/e-sasha-permissions";

interface IMenuName {
    nameSection: string;
    nameCard: string;
}

export enum ESectionId {
    informations = 'informations',
    technicalsInformations = 'technicalsInformations',
    travellers = 'travellers',
    contacts = 'contacts',
    qualityControl = 'qualityControl',
    price = 'price',
    fareOptimisation = 'fareOptimisation',
    remarks = 'remarks',
    bookingOperations = 'bookingOperations',
    bookingServices = 'bookingServices',
    ancillaryServices = 'ancillaryServices',
    sectors = 'sectors'
}

@Component({
    selector: 'menu',
    template: `
        <div sticky [offset]="offset" id="menu" [elementInitialPositionStrategy]="elementInitialPositionStrategy">
            <span class="booking-code menu-item active"
                  [class.active]="sectionId === sectionIds.informations">

                <span class="e2e-booking-code" (click)="goToAnchorAndModifyUrl(sectionIds.informations)"> {{ code }} </span>

                <btn class="toggle"
                     type="actionHeaderLink"
                     classList="no-spacing"
                     (click)="toggleCards()">
                    <fa-icon [icon]="isCardsShown ? iconAngleDoubleUp : iconAngleDoubleDown" class="icon"></fa-icon>
                </btn>
            </span>

            
            <!-- TODO : inconsistency between function attribute and condition -->
            <div class="menu-item"
                 [class.active]="sectionId === sectionIds.technicalsInformations"
                 (click)="goToAnchorAndModifyUrl('identification')">
                <span>{{ menuItemsLabels.identification }}</span>
            </div>

            <ng-container *permissionIf="sashaPermissions.SASHA_QUALITY_CHECK_SHOW">
                <div class="menu-item" *ngIf="booking?.booking && booking?.booking?.qualityCheck && (booking.booking.qualityCheck.status | isInArrayPipe : validStatus)"
                     [class.active]="sectionId === sectionIds.qualityControl"
                     (click)="goToAnchorAndModifyUrl(sectionIds.qualityControl)">
                    <fa-icon [icon]="icon" class="{{cssClass}}"></fa-icon>
                    <span class="item-menu">
                    {{ menuItemsLabels.qualityControl }}
                </span>
                </div>
            </ng-container>

            <div class="menu-item"
                 *ngIf="showFareOptimisation"
                 [class.active]="sectionId === sectionIds.fareOptimisation"
                 (click)="goToAnchorAndModifyUrl(sectionIds.fareOptimisation)">
                <fa-icon [icon]="iconMoney"></fa-icon>
                <span class="item-menu">
                {{ menuItemsLabels.fareOptimisation }}
                </span>
            </div>

            <div class="menu-item"
                 *ngIf="isVehicleRentalBooking"
                 [class.active]="sectorIsActive(sectionId)"
                 (click)="goToAnchorAndModifyUrl(sectionIds.sectors)">
                <span>{{ menuItemsLabels.sectors }}</span>
            </div>

            <div class="menu-item"
                 *ngIf="sectors"
                 [class.active]="sectorIsActive(sectionId)"
                 (click)="goToAnchorAndModifyUrl(sectionIds.sectors)">
                <span>{{ menuItemsLabels.sectors }}</span>
            </div>
            <div class="resume-sectors">
                <div *ngFor="let sector of sectors; let lastSector = last">
                    <div class="resume-sector"
                         [class.active]="'sector_'+ sector.xId === sectionId"
                         (click)="goToAnchorAndModifyUrl('sector_'+ sector.xId)">
                        <fa-icon [icon]="iconCircleThin" class="icon-circle-thin"></fa-icon>
                        <fa-icon [icon]="iconCircle" class="icon-circle"></fa-icon>
                        <stay-summary-menu *ngIf="sector.xType === 'stay'"
                                           [booking]="booking" [sector]="sector"></stay-summary-menu>
                        <air-summary-menu *ngIf="sector.xType === 'air'"
                                          [booking]="booking" [sector]="sector"></air-summary-menu>
                    </div>
                    <fa-icon [icon]="iconLongArrowDown"
                             *ngIf="!lastSector"
                             class="icon-arrow">
                    </fa-icon>
                </div>
            </div>

            <div class="menu-item e2e-menu-travellers"
                 [class.active]="sectionId === sectionIds.travellers"
                 (click)="goToAnchorAndModifyUrl(sectionIds.travellers)">
                <span>{{ menuItemsLabels.travellers }}</span>
            </div>

            <div class="menu-item"
                 [class.active]="sectionId === sectionIds.contacts"
                 (click)="goToAnchorAndModifyUrl(sectionIds.contacts)">
                <span>{{ menuItemsLabels.contacts }}</span>
            </div>

            <ng-container  *ngIf="booking.price?.length">
                <div class="menu-item"
                     *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW"
                     [class.active]="sectionId === sectionIds.price"
                     (click)="goToAnchorAndModifyUrl(sectionIds.price)">
                    <span>{{ menuItemsLabels.pricing }}</span>
                </div>
            </ng-container>
            

            <div class="menu-item e2e-remarks"
                 *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_REMARKS_SHOW"
                 [class.active]="sectionId === sectionIds.remarks"
                 (click)="goToAnchorAndModifyUrl(sectionIds.remarks)">
                <span>{{ menuItemsLabels.remarks }}</span>
            </div>

            <ng-container *ngIf="showServicesAndOperations">
                <div class="menu-item"
                     *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_OPERATIONS_SHOW"
                     [class.active]="sectionId === sectionIds.bookingOperations"
                     (click)="goToAnchorAndModifyUrl(sectionIds.bookingOperations)">
                    <span>{{ menuItemsLabels.bookingOperations }}</span>
                </div>

                <div class="menu-item"
                     *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_SERVICES_SHOW"
                     [class.active]="sectionId === sectionIds.bookingServices"
                     (click)="goToAnchorAndModifyUrl(sectionIds.bookingServices)">
                    <span>{{ menuItemsLabels.bookingServices }}</span>
                </div>
            </ng-container>

            <!--            <ng-container >-->
            <!--                <div class="menu-item"-->
            <!--                     [class.active]="sectionId === 'bookingFareOptHistory'"-->
            <!--                     (click)="goToAnchor('bookingFareOptHistory')">-->
            <!--                    <span>{{ menuItemsLabels.bookingFareOptHistory }}</span>-->
            <!--                </div>-->
            <!--            </ng-container>-->


            <ng-container *ngIf="hasServices">
                <div class="menu-item"
                     *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_VIEW"
                     [class.active]="sectionId === sectionIds.ancillaryServices"
                     (click)="goToAnchorAndModifyUrl(sectionIds.ancillaryServices)">
                    <span>{{ menuItemsLabels.ancillaryServices }}</span>
                </div>
            </ng-container>


        </div>
    `,
    styles: [`
        .icon-arrow {
            position: relative;
            left: 12px;
            font-size: 1.25rem;
        }

        .menu-item {
            padding: 10px 15px;
            cursor: pointer;
        }

        .resume-sectors
        .menu-item:hover {
            background-color: #f2f2f2;
        }

        .menu-item.active {
            background-color: #ecf0f1;
        }

        .resume-sector .icon-circle,
        .resume-sector.active .icon-circle-thin,
        .resume-sector:hover .icon-circle-thin {
            display: none;
        }

        .resume-sector .icon-circle-thin,
        .resume-sector.active .icon-circle,
        .resume-sector:hover .icon-circle {
            display: block;
        }

        .booking-code {
            padding: 10px 15px;
            font-size: 1.5rem;
            color: #2b78e4;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        #menu {
            display: flex;
            flex-direction: column;
            width: 230px;
            margin-right: 15px;
            background-color: #fff;
            border: 1px solid rgba(189, 195, 199, 0.2);
            /* #29248 add those lines to avoid margin glitch on booking page*/
            position: absolute;
            top: unset;
        }

        .menu-item + .resume-sectors {
            display: none;
        }

        .menu-item.active + .resume-sectors {
            display: block;
        }

        stay-summary-menu, air-summary-menu {
            flex: 1;
            display: block;
            margin-left: 10px;
            padding: 7px;
            cursor: pointer;
        }

        .resume-sectors {
            max-height: 50vh;
            overflow-y: auto;
        }

        .resume-sector {
            display: flex;
            align-items: center;
            margin: 0 10px;
        }

        .resume-sector:last-child {
            padding-bottom: 10px;
        }

        .item-menu {
            color: #a94442;
        }

        .warning {
            color: #8a6d3b;
        }
    `]
})
export class MenuComponent implements OnChanges, OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
    @Input()
    public elementInitialPositionStrategy: 'absolute' | 'relative' = 'relative';

    @Input()
    public code: string;

    @Input()
    public isCardsShown: boolean = true;

    @Input()
    public booking: IGetBookingsStayResponse | IGetBookingsAirResponse;

    @Input()
    public showServicesAndOperations: boolean = true;

    @Input()
    public hasServices: boolean = false;

    @Input()
    public isVehicleRentalBooking: boolean = false;

    @Input()
    public showFareOptimisation: boolean = false;

    @Output()
    public readonly onToggleCards: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public readonly onMenuTitleClick: EventEmitter<string> = new EventEmitter();
    public validStatus: string[] = ['SUCCESS', 'ACTION_PERFORMED', 'NO_ACTION_REQUIRED', 'NO_MORE_ACTION_REQUIRED'];
    public sectors: ISummarySectorStay[] | ISummarySectorAir[];
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    public sectionIds: typeof ESectionId = ESectionId;


    public offset: number = 60;
    public menuItemsLabels: ILabels = MENU_ITEMS_LABELS;

    public readonly informationCardSection: IMenuName[] = [
        {nameSection: 'informations', nameCard: 'bookingMainInformation'},
        {nameSection: 'sectors', nameCard: 'sectors'},
        {nameSection: 'travellers', nameCard: 'bookingTraveller'},
        {nameSection: 'contacts', nameCard: 'bookingContacts'},
        {nameSection: 'price', nameCard: 'bookingPrice'},
        {nameSection: 'remarks', nameCard: 'bookingRemarks'},
        {nameSection: 'fareOptimisation', nameCard: 'fareOptimisation'},
        {nameSection: 'identification', nameCard: 'bookingTechnicalInformations'},
        {nameSection: 'bookingOperations', nameCard: 'bookingOperations'},
        {nameSection: 'bookingServices', nameCard: 'bookingServices'},
        {nameSection: 'bookingFareOptHistory', nameCard: 'bookingFareOptHistory'},
        {nameSection: 'ancillaryServices', nameCard: 'ancillaryServices'},
        {nameSection: 'qualityControl', nameCard: 'bookingQualityControl'},
    ];

    public dates: {
        begin: string;
        end: string;
        duration: number;
    };

    @Input()
    public sectionId: string = null;

    public firstCardOffsetTop: number = 0;
    public sections: HTMLElement[] = [];
    public airBookingPermissions: typeof EAirBookingPermissions = EAirBookingPermissions;

    public iconAngleDoubleDown: IconDefinition = faAngleDoubleDown;
    public iconAngleDoubleUp: IconDefinition = faAngleDoubleUp;
    public iconCircleThin: IconDefinition = faCircleThin;
    public iconCircle: IconDefinition = faCircle;
    public iconLongArrowDown: IconDefinition = faLongArrowAltDown;
    public icon: IconDefinition;
    public iconMoney: IconDefinition;
    public cssClass: string;
    private goToAnchorSubscription: Subscription;
    private currentFragment: string;

    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly sectorService: SectorService,
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly viewportScroller: ViewportScroller,
        private readonly router: Router,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly errorTracingService: ErrorTracingService,
        private readonly menuService: MenuService
    ) {
    }

    public ngOnInit(): void {
        this.initSectors();
        this.viewportScroller.setOffset([0, this.offset]);
        this.icon = faExclamationTriangle;
        this.iconMoney = faMoneyBill;
        this.cssClass = "warning";
        this.initGoToAnchorSubscription();
    }


    public ngAfterViewInit(): void {
        this.sections = Array.from(this.document.querySelectorAll('.sections'));

        if (this.sections.length) {
            this.firstCardOffsetTop = this.sections[0].getBoundingClientRect().top;

            this.activatedRoute.fragment
                .pipe(
                    delay(100),
                    take(1),
                    map((fragment: string): string => fragment),
                    tap((fragment: string): void => {
                        if(fragment !== this.currentFragment){
                            this.currentFragment = fragment;
                            if(fragment){
                                this.goToAnchor(fragment);
                            }
                        }

                    })
                ).subscribe({
                error: (error: Error): void => {
                    this.errorTracingService.captureException(error);
                }
            });
        }
    }

    public ngAfterViewChecked(): void {
        this.changeDetector.detectChanges();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.booking && !changes.booking.isFirstChange()) {
            this.initSectors();
        }
    }

    public ngOnDestroy(): void {
        this.goToAnchorSubscription.unsubscribe();
    }



    public toggleCards(): void {
        const isCardsShown: boolean = !this.isCardsShown;
        this.onToggleCards.emit(isCardsShown);
    }

    public async goToAnchorAndModifyUrl(section: string): Promise<void> {
        this.goToAnchor(section);
        const url: string = this.router.url.split('#')[0];

        await this.router.navigate([decodeURI(url)], {fragment: section, replaceUrl: true});
    }
    public goToAnchor(section: string): void {
        const cardName: string = this.informationCardSection
            .find((cardInformation: IMenuName): boolean => cardInformation.nameSection === section)
            .nameCard;

        this.onMenuTitleClick.emit(cardName);
        this.viewportScroller.scrollToAnchor(section);
        this.sectionId = section;
    }

    //TODO : use pipe instead of this function for performance
    public sectorIsActive(sectionId: string): boolean {
        return Array.from(this.document.querySelectorAll('.resume-sector'))
            .some((sector: HTMLElement) => sector.classList.contains('active')) || sectionId === ESectionId.sectors;
    }

    @HostListener('window:scroll', [])
    public async onWindowScroll(): Promise<void> {
        const section: HTMLElement = getCurrentSection(this.sections, this.offset);
        this.sectionId = section && section.id || undefined;
        const url: string = this.router.url.split('#')[0];
        await this.router.navigate([decodeURI(url)], {fragment: this.sectionId, replaceUrl: true});
    }

    private initGoToAnchorSubscription(): void {
        this.goToAnchorSubscription = this.menuService.goToAnchorObservable.subscribe((section: string): void => {
            this.goToAnchorAndModifyUrl(section);
        });
    }

    private initSectors(): void {
        this.sectors = this.booking?.sector ? this.sectorService.getSectors(this.booking) : null;
    }
}


function getCurrentSection(sections: HTMLElement[], offset: number): HTMLElement {
    const currentTop: number = offset;
    const currentBottom: number = window.innerHeight - offset;
    let fallbackNode: HTMLElement = undefined;

    for (const section of sections) {
        const {top, bottom}: { top: number, bottom: number } = section.getBoundingClientRect();

        if (currentBottom < top && bottom >= currentTop && !fallbackNode) {
            fallbackNode = section;
        }

        if (currentTop <= top && bottom >= currentTop) {
            return section;
        }
    }

    return fallbackNode;
}
